import { defineStore } from 'pinia'
import { fetchJson } from '~/composables/request'
import { cryptoAES } from '@/utils/cryptoUtil'

import { useGlobalStore } from '#imports'
interface bestVideo {
  bestData: any[]
}
export const useBestsStore = defineStore('bestVideo', {
  state: (): bestVideo => {
    return {
      bestData: []
    }
  },
  actions: {
    async getData() {
      const { jsonApi, tenantId,webSiteId } = useGlobalStore()
      try { 
        //   tv/{tenantId}/{webSiteId}/water/{channelId}/0.json
        const data = await fetchJson(`${jsonApi}/pages/best/${tenantId}/${webSiteId}/best.json`)
        // 确保data是数组
        this.bestData = Array.isArray(data) ? data : []
        // console.log(this.bestData, '=== this.bestData ===');
      } catch (error) {
        console.log(error);
        this.bestData = []
      }
    }
  }
  // 开始数据持久化
  // persist: process.client && {
  //   key: 'searchData',
  //   storage: process.client && window.localStorage
  // }
})
